"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var styled_1 = __importDefault(require("@emotion/styled"));

var themes_1 = require("./themes");

var polished_1 = require("polished");

var StyledButton = styled_1.default.button(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  white-space: nowrap;\n  width: auto;\n  padding: 5px 10px;\n  text-decoration: none;\n  color: inherit;\n  background-color: transparent;\n  border: none;\n  cursor: pointer;\n  text-align: left;\n  align-self: stretch;\n  display: flex;\n  align-items: center;\n"], ["\n  white-space: nowrap;\n  width: auto;\n  padding: 5px 10px;\n  text-decoration: none;\n  color: inherit;\n  background-color: transparent;\n  border: none;\n  cursor: pointer;\n  text-align: left;\n  align-self: stretch;\n  display: flex;\n  align-items: center;\n"])));
exports.List = styled_1.default.ul(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  font-size: 1rem;\n  line-height: 1.75rem;\n  font-weight: 400;\n  letter-spacing: 0.009375em;\n  text-decoration: inherit;\n  text-transform: inherit;\n  line-height: 1.5rem;\n  margin: 0;\n  padding: 8px 0;\n  list-style-type: none;\n"], ["\n  font-size: 1rem;\n  line-height: 1.75rem;\n  font-weight: 400;\n  letter-spacing: 0.009375em;\n  text-decoration: inherit;\n  text-transform: inherit;\n  line-height: 1.5rem;\n  margin: 0;\n  padding: 8px 0;\n  list-style-type: none;\n"])));
exports.ListItem = styled_1.default.li(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  display: flex;\n  position: relative;\n  flex-direction: column;\n  padding: ", ";\n  border-bottom: ", ";\n\n  ", ";\n  ", ";\n  cursor: ", ";\n\n  &:hover {\n    ", ";\n    ", ";\n  }\n"], ["\n  display: flex;\n  position: relative;\n  flex-direction: column;\n  padding: ", ";\n  border-bottom: ", ";\n\n  ", ";\n  ", ";\n  cursor: ", ";\n\n  &:hover {\n    ", ";\n    ", ";\n  }\n"])), function (_a) {
  var theme = _a.theme,
      padding = _a.padding,
      inCard = _a.inCard;
  return padding ? padding : theme.default.padding / 2 + "px " + (inCard ? theme.card.paddingHorizontal : theme.default.padding) + "px";
}, function (_a) {
  var border = _a.border,
      theme = _a.theme;

  var _b, _c, _d, _e;

  return !border ? 'none' : '1px solid ' + polished_1.rgba((_e = (_d = (_c = (_b = theme) === null || _b === void 0 ? void 0 : _b.colors) === null || _c === void 0 ? void 0 : _c.surface) === null || _d === void 0 ? void 0 : _d.onColor, _e !== null && _e !== void 0 ? _e : themes_1.defaultTheme.colors.surface.onColor), 0.125);
}, function (_a) {
  var active = _a.active,
      theme = _a.theme,
      inheritColors = _a.inheritColors;

  var _b, _c, _d, _e, _f, _g, _h, _j;

  return "color: " + (inheritColors ? 'inherit' : active ? (_e = (_d = (_c = (_b = theme) === null || _b === void 0 ? void 0 : _b.colors) === null || _c === void 0 ? void 0 : _c.primary) === null || _d === void 0 ? void 0 : _d.onColor, _e !== null && _e !== void 0 ? _e : themes_1.defaultTheme.colors.primary.onColor) : (_j = (_h = (_g = (_f = theme) === null || _f === void 0 ? void 0 : _f.colors) === null || _g === void 0 ? void 0 : _g.surface) === null || _h === void 0 ? void 0 : _h.onColor, _j !== null && _j !== void 0 ? _j : themes_1.defaultTheme.colors.surface.onColor));
}, function (_a) {
  var active = _a.active,
      theme = _a.theme,
      inheritColors = _a.inheritColors;

  var _b, _c, _d, _e;

  return "background-color: " + (inheritColors ? 'inherit' : active ? (_e = (_d = (_c = (_b = theme) === null || _b === void 0 ? void 0 : _b.colors) === null || _c === void 0 ? void 0 : _c.primary) === null || _d === void 0 ? void 0 : _d.color, _e !== null && _e !== void 0 ? _e : themes_1.defaultTheme.colors.primary.color) : 'transparent');
}, function (_a) {
  var onClick = _a.onClick;
  return onClick ? 'pointer' : 'default';
}, function (_a) {
  var theme = _a.theme,
      highlight = _a.highlight,
      active = _a.active;

  var _b, _c, _d, _e;

  return highlight && !active ? 'color: ' + (_e = (_d = (_c = (_b = theme) === null || _b === void 0 ? void 0 : _b.colors) === null || _c === void 0 ? void 0 : _c.highlight) === null || _d === void 0 ? void 0 : _d.onColor, _e !== null && _e !== void 0 ? _e : themes_1.defaultTheme.colors.highlight.onColor) : '';
}, function (_a) {
  var theme = _a.theme,
      highlight = _a.highlight,
      active = _a.active;

  var _b, _c, _d, _e;

  return highlight && !active ? 'background-color: ' + (_e = (_d = (_c = (_b = theme) === null || _b === void 0 ? void 0 : _b.colors) === null || _c === void 0 ? void 0 : _c.highlight) === null || _d === void 0 ? void 0 : _d.color, _e !== null && _e !== void 0 ? _e : themes_1.defaultTheme.colors.highlight.color) : '';
});
var templateObject_1, templateObject_2, templateObject_3;